import './Logo.css';
function Logo() {
  return (
    <div className="Logo">
        <img className='img1' src='/pixelforge-logo.png' alt='PixelForge' />
        <img className='img2' src='/pixelforge-logo.png' alt='PixelForge' />
        <span className='logo-text'>PixelForge</span>
    </div>
  );
}

export default Logo;
